import { render } from "./MenuView.vue?vue&type=template&id=216b197b&scoped=true"
import script from "./MenuView.vue?vue&type=script&lang=js"
export * from "./MenuView.vue?vue&type=script&lang=js"

import "./MenuView.vue?vue&type=style&index=0&id=216b197b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kobayashi.y\\develop\\thxily_fastapi\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216b197b"]])

export default __exports__